module.exports = __webpack_public_path__ + "img/logo_ssstock@3x.b5028883.png";